import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import useRequest from "../../../hooks/useRequest";
import { downloadExcel, stringLimit } from "../../../util/fn";
import Pagination from "../../Pagination/Pagination";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ViewAll = (props) => {
  const {
    outlets,
    vendorType,
    startDate,
    endDate,
    outletId: Id,
  } = props?.location?.state;

  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const [outletId, setOutletId] = useState(
    outlets?.length ? outlets[0]?._id : Id
  );
  const { request: requestCities, response: responseCities } = useRequest();
  const { request: request, response: response } = useRequest();
  const [reportData, setReportData] = useState({
    totalBooking: 0,
    totalCommission: 0,
    totalPerson: 0,
    totalRevenue: 0,
  });

  const [startDateVal, setStartDateVal] = useState(
    params.get("startDate") || ""
  );
  const [endDateVal, setEndDateVal] = useState(params.get("endDate") || "");
  const [minEndDate, setMinEndDate] = useState(startDate);
  const [maxStartDate, setMaxStartDate] = useState(endDate);
  const [cities, setCities] = useState([]);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([
    { title: "S.No." },
    { title: "Name" },
    { title: "Total Guest" },
    { title: "Total Billing" },
    { title: "Sortyfy Commission" },
    { title: "Outlet Pay Balance" },
    { title: "Payment Status" },
  ]);
  const perPage = 10;
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [page, setPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [search, setSearch] = useState();

  useEffect(() => {
    document.title = "Finance Report - Sportyfy";

    requestCities("GET", "admin/vendor/getCity");
    request("POST", `admin/report/financeReportOutlet`, {
      perPage,
      page,
      searchString: "",
      outletId,
      startDate: startDate,
      endDate: endDate,
    });
  }, []);

  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);
      }
    }
  }, [responseCities]);

  const outletHandler = (e) => {
    e.preventDefault();
    if (e.target.value) {
      const startDate = document.getElementById("startDate").value;
      const endDate = document.getElementById("endDate").value;
      request("POST", `admin/report/financeReportOutlet`, {
        perPage,
        page,
        outletId: e.target.value,
        searchString: "",
        startDate,
        endDate,
      });
      setOutletId(e.target.value);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (response) {
      if (response.status && response.data) {
        // if(response.data && response.data.length>0){
        setData(response.data);
        setReportData({
          totalBooking: response?.totalBooking || 0,
          totalCommission: response?.totalCommission || 0,
          totalPerson: response?.totalPerson || 0,
          totalRevenue: response?.totalRevenue || 0,
        });
        setTotalDocuments(response.totalCount);
        // }
      }
    }
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setPage(selected + 1);
    if (selected + 1 == 1) {
      setStartIndex(1);
    } else {
      setStartIndex(selected * perPage + 1);
    }
    request("POST", `admin/report/financeReportOutlet`, {
      perPage,
      page: selected + 1,
      searchString: search,
      outletId,
    });
  };
  const handleStartDate = (e) => {
    if (e.target.value) {
      setMinEndDate(e.target.value);
      setStartDateVal(e.target.value);
    } else {
      setMinEndDate("");
      setStartDateVal("");
    }
  };

  const handleEndDate = (e) => {
    if (e.target.value) {
      setMaxStartDate(e.target.value);
      setEndDateVal(e.target.value);
    } else {
      setMaxStartDate("");
      setEndDateVal("");
    }
  };
  const downloadExcelHandler = () => {
    let xlData = [];
    if (data && data.length > 0) {
      let count = 1;
      data.forEach((obj) => {
        xlData.push({
          "Sr.": count,
          Name: obj?.name,
          "Total Guest": obj?.totalGuest,
          "Total Billing": obj?.totalBilling,
          "Sortyfy Commission": obj?.sortyfyCommission,
          "Outlet Pay Balance": obj?.outletPaybal,
          "Payment Status": obj?.paymentStatus,
        });
        count = count + 1;
      });
    } else {
      xlData.push({
        "Sr.": "",
        Name: "",
        "Total Guest": "",
        "Total Billing": "",
        "Sortyfy Commission": "",
        "Outlet Pay Balance": "",
        "Payment Status": "",
      });
    }
    downloadExcel(xlData, "Finance Reports");
  };
  const filterHandler = () => {
    const startDate = document.getElementById("startDate").value;
    const endDate = document.getElementById("endDate").value;
    // const status = document.getElementById('status').value;
    // const city = document.getElementById("cities").value;
    request("POST", `admin/report/financeReportOutlet`, {
      perPage,
      page,
      searchString: search,
      startDate,
      endDate,
      outletId,
    });
    // dispatch(
    //   getBusinessReports({
    //     startDate,
    //     endDate,
    //     status,
    //     outletId: selectedOutletId,
    //   })
    // );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    let searchString = search;
    const city = document.getElementById("cities").value;
    if (e.target.name == "search") {
      setSearch(e.target.value);
      searchString = e.target.value;
    }
    searchString = searchString ?? "";
    request("POST", `admin/report/financeReportOutlet`, {
      perPage,
      page,
      searchString: searchString,
      outletId,
    });
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title={"Finance Report Outlet"}
            links={[
              { to: "/", name: "Home" },
              {
                to: `/finance-report?cityId=${
                  params.get("cityId") || ""
                }&startDate=${startDateVal || ""}&endDate=${endDateVal || ""}`,
                name: "Report",
              },
            ]}
          />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-6">
                  <h6>{"Finance Report History"}</h6>
                </div>
                <div className="col-md-4">
                  {vendorType === "multiple" && (
                    <div className="form-group">
                      <label htmlFor="outlet">Outlet:</label>
                      <select
                        className="form-control"
                        id="outlet"
                        onChange={outletHandler}
                        value={outletId}
                      >
                        <option value={""}>Select</option>
                        {outlets &&
                          outlets.length > 0 &&
                          outlets.map((obj) => (
                            <option key={obj._id} value={obj._id}>
                              {obj.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="search">Search:</label>
                    <input
                      type="text"
                      className="form-control"
                      id="search"
                      name="search"
                      placeholder="Search by Name"
                      onChange={handleSearch}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="date-filter">
                <Row>
                  <Col md={4}>
                    <div className="startDate">
                      {/* date picker input */}
                      <label htmlFor="validationCustom01" class="form-label">
                        Start Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="startDate"
                        name="startDate"
                        value={startDateVal}
                        placeholder="Start Date"
                        max={maxStartDate}
                        onChange={handleStartDate}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="endDate">
                      <label htmlFor="validationCustom01" class="form-label">
                        End Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="endDate"
                        name="endDate"
                        placeholder="End Date"
                        value={endDateVal}
                        min={minEndDate}
                        onChange={handleEndDate}
                        // onChange={filterData}
                      />
                    </div>
                  </Col>
                  {/* <Col md={2}>
                                        <div className="endDate">
                                            <label htmlFor="validationCustom01" class="form-label">
                                                Status
                                            </label>
                                            <select
                                                className="form-control"
                                                id="status"
                                                name="status"
                                            // onChange={filterData}
                                            >
                                                <option value={""}>Please select</option>
                                                <option value={"accepted"}>Accepted</option>
                                                <option value={"pending"}>Pending</option>
                                                <option value={"decline"}>Decline</option>
                                            </select>
                                        </div>
                                    </Col> */}
                  <Col md={2}>
                    <button
                      type="button"
                      onClick={filterHandler}
                      className="excle-dowm"
                    >
                      {" "}
                      Filter{" "}
                    </button>
                  </Col>
                  <Col md={2}>
                    {/* <DownloadTableExcel
                        filename="Business Reports"
                        sheet="Business Reports"
                        currentTableRef={tableRef.current}
                      >
                        <button
                          className="excle-dowm"
                          disabled={!(currentItems?.length > 0)}
                        >
                          {" "}
                          Export excel{" "}
                        </button>
                      </DownloadTableExcel> */}
                    <button
                      type="button"
                      onClick={downloadExcelHandler}
                      className="excle-dowm"
                    >
                      {" "}
                      Export excel{" "}
                    </button>
                  </Col>
                </Row>
              </div>
              <div className="dh-section mt-4">
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <div className="ms-card ms-widget has-graph-full-width ms-infographics-widget">
                      <div className="ms-card-body media">
                        <div className="media-body">
                          <span className="black-text">
                            <strong>Total Booking</strong>
                          </span>
                          <h2>{reportData?.totalBooking}</h2>
                        </div>
                      </div>
                      {/* <LineChart data={this.state.data1} options={options} /> */}
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <div className="ms-card ms-widget has-graph-full-width ms-infographics-widget">
                      {/* <span className="ms-chart-label bg-red">
                            <i className="material-icons">arrow_downward</i>{" "}
                            4.5%
                          </span> */}
                      <div className="ms-card-body media">
                        <div className="media-body">
                          <span className="black-text">
                            <strong>Total Person</strong>
                          </span>
                          <h2>{reportData?.totalPerson}</h2>
                        </div>
                      </div>
                      {/* <LineChart data={this.state.data2} options={options} /> */}
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <div className="ms-card ms-widget has-graph-full-width ms-infographics-widget">
                      <div className="ms-card-body media">
                        <div className="media-body">
                          <span className="black-text">
                            <strong>Total Revenue</strong>
                          </span>
                          <h2>{reportData?.totalRevenue}</h2>
                        </div>
                      </div>
                      {/* <LineChart data={this.state.data3} options={options} /> */}
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <div className="ms-card ms-widget has-graph-full-width ms-infographics-widget">
                      <div className="ms-card-body media">
                        <div className="media-body">
                          <span className="black-text">
                            <strong>Total Commission</strong>
                          </span>
                          <h2>{reportData?.totalCommission}</h2>
                        </div>
                      </div>
                      {/* <LineChart data={this.state.data3} options={options} /> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* <Col md={12}>
                <div className="text-center border-classss mt-4">
                  <h5 className="mt-4">Payment Gateway</h5>
                </div>

                <div className="table-responsive mt-5">
                  <table className="table table-hover thead-primary">
                    <thead>
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Booking ID</th>
                        <th scope="col">Order ID</th>
                        <th scope="col">Username</th>
                        <th scope="col">Guest Name</th>
                        <th scope="col">Booking Made On</th>
                        <th scope="col">Date of Booking</th>
                        <th scope="col">Number of Guests</th>
                        <th scope="col">Booked For</th>
                        <th scope="col">Billing Amount</th>
                        <th scope="col">Outlet Discount</th>
                        <th scope="col">Sortyfy Discount</th>
                        <th scope="col">Billed Amount</th>
                        <th scope="col">Tax </th>
                        <th scope="col">Tax Amount</th>
                        <th scope="col">Final Amount After Tax</th>
                        <th scope="col">Reward Points Accrued</th>
                        <th scope="col">Reward Amount</th>
                        <th scope="col">Guest Payable Bill Amount</th>
                        <th scope="col">Advanced Table Amount Adjusted</th>
                        <th scope="col">Payment Done by Guest</th>
                        <th scope="col">Paid Through</th>
                        <th scope="col">Payment Cleared At</th>
                        <th scope="col">Outlet Payment Status</th>
                        <th scope="col">Sortyfy Commission</th>
                        <th scope="col">Commission Amount</th>
                        <th scope="col">Payment Gateway Charge</th>
                        <th scope="col">Payment Gateway Amount</th>
                        <th scope="col">Gateway Charge</th>
                        <th scope="col">Tech Assistance</th>
                        <th scope="col">
                          Payment Made to Outlet through Sortyfy
                        </th>
                        <th scope="col">No-Show</th>
                        <th scope="col">No-Show Amount</th>
                        <th scope="col">Full & Final Payment Settlement</th>
                        <th scope="col">Payment Status</th>
                        <th scope="col">Commission Payment Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length ? (
                        data?.map((report, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{report?.bookingNumber}</td>
                              <td>{report?.orderId}</td>
                              <td>{report?.userName}</td>
                              <td>{report?.guestName}</td>
                              <td>{report?.bookingMadeOn}</td>
                              <td>{report?.dateOfBooking}</td>
                              <td>{report?.numberOfGuest}</td>
                              <td>{report?.bookedFor}</td>
                              <td>{report?.billingAmount}</td>

                              <td>
                                {report?.outletDiscount > 0
                                  ? report?.outletDiscount
                                  : "0"}
                              </td>
                              <td>{report?.sortyfyDiscount}</td>
                              <td>{report?.billedAmount}</td>
                              <td>
                                {report?.tax?.map((vals, i) => (
                                  <span key={i}>
                                    {`${vals?.title}: ${vals?.amount}`},
                                  </span>
                                ))}
                              </td>
                              <td>{report?.taxAmount}</td>
                              <td>{report?.finalAmountAfterTax}</td>
                              <td>{report?.rewardPoint}</td>
                              <td>{report?.rewardAmount}</td>
                              <td>{report?.billedAmountAfterReward}</td>
                              <td>{report?.advanceTableAmount}</td>
                              <td>{report?.paymentDoneByGuest}</td>
                              <td>{report?.paidThrough}</td>
                              <td>{report?.paymentClearedAt}</td>
                              <td>{report?.outletPaymentStatus}</td>
                              <td>{report?.sortyfyCommission}</td>
                              <td>{report?.commissionAmount}</td>
                              <td>{report?.paymentGatewayCharge}</td>
                              <td>{report?.paymentGatewayAmount}</td>

                              <td>{report?.gatewayCharge}</td>
                              <td>{report?.techAssistance}</td>
                              <td>{report?.paymentMadeToOutletFromSortyfy}</td>
                              <td>{report?.noShowPercent}</td>
                              <td>{report?.noShowAmount}</td>
                              <td>{report?.fullFinalPaymentSettlement}</td>
                              <td>{report?.paymentStatus}</td>
                              <td>{report?.commissionPaymentDetails}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center" }} colSpan="7">
                            No Reports Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col> */}

              <Col md={12}>
                <div className="text-center border-classss mt-4">
                  <h5 className="mt-4">Payment Gateway</h5>
                </div>

                <div className="table-responsive mt-5">
                  <table
                    className="table table-hover thead-primary"
                    // ref={tableRef}
                  >
                    <thead>
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Booking ID</th>
                        <th scope="col">Username</th>
                        <th scope="col">Guest Name</th>
                        <th scope="col">Booking Made On</th>
                        <th scope="col">Date of Booking</th>
                        <th scope="col">Number of Guests</th>
                        <th scope="col">Booked For</th>
                        <th scope="col">Gross Amount</th>
                        <th scope="col">Outlet Discount</th>
                        <th scope="col">Sortyfy Discount</th>
                        <th scope="col">Discount Amount</th>
                        <th scope="col">After Discount</th>
                        <th scope="col">Tax </th>
                        <th scope="col">Tax Amount</th>
                        <th scope="col"> Amount After Tax</th>
                        <th scope="col">Reward Points Accrued</th>
                        <th scope="col">Reward Amount</th>
                        <th scope="col">Guest Payable Bill Amount</th>
                        <th scope="col">Advanced Table Amount Adjusted </th>
                        <th scope="col">Delivery Charge </th>
                        <th scope="col"> Delivery Tax</th>

                        <th scope="col">Payment Done by Guest</th>
                        <th scope="col">Paid Through</th>
                        <th scope="col">Payment Cleared At</th>
                        <th scope="col">Outlet Payment Status</th>
                        <th scope="col">Sortyfy Commission</th>
                        <th scope="col">Commission Amount</th>
                        <th scope="col">All Services Vendor</th>
                        <th scope="col"> Total Services Charges Vendor</th>
                        <th scope="col"> Tax On Service Charge Vendor</th>

                        <th scope="col">All Services Guest</th>
                        <th scope="col"> Total Services Charges Guest</th>
                        <th scope="col"> Tax On Service Charge Guest</th>

                        {/* <th scope="col">Platform Charge</th>
                              <th scope="col">Gateway Charge</th>
                              <th scope="col">Tech Assistance</th> */}
                        <th scope="col">
                          {" "}
                          Payment Made to Outlet through Sortyfy
                        </th>
                        <th scope="col">No-Show</th>
                        <th scope="col">No-Show Amount</th>
                        <th scope="col">Full & Final Payment Settlement</th>
                        <th scope="col">Payment Status</th>
                        <th scope="col"> Payment Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length ? (
                        data?.map((report, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{report?.bookingNumber}</td>
                              <td>{report?.userName}</td>
                              <td>{report?.guestName}</td>
                              <td>{report?.bookingMadeOn}</td>
                              <td>{report?.dateOfBooking}</td>
                              <td>{report?.numberOfGuest}</td>
                              <td>{report?.bookedFor}</td>
                              <td>{report?.billingAmount}</td>
                              <td>
                                {report?.outletDiscount
                                  ? report?.outletDiscount
                                  : "0"}
                              </td>
                              <td>{report?.sortyfyDiscount}</td>
                              <td>{report?.discountAmount}</td>
                              <td>{report?.billedAmount}</td>
                              <td>
                                {Array.isArray(report?.tax) &&
                                  report.tax.map((vals, i) => (
                                    <span key={i}>
                                      {`${vals?.title}: ${vals?.amount}`}
                                      {i < report.tax.length - 1 ? ", " : ""}
                                    </span>
                                  ))}
                              </td>
                              <td>{report?.taxAmount}</td>
                              <td>{report?.finalAmountAfterTax}</td>
                              <td>{report?.rewardPoint}</td>
                              <td>{report?.rewardAmount}</td>
                              <td>{report?.billedAmountAfterReward}</td>
                              <td>{report?.advanceTableAmount}</td>
                              <td>{report?.deliveryCharge}</td>
                              <td>{report?.deliveryTax}</td>
                              <td>{report?.paymentDoneByGuest}</td>
                              <td>{report?.paidThrough}</td>
                              <td>{report?.paymentClearedAt}</td>
                              <td>{report?.outletPaymentStatus}</td>
                              <td>{report?.sortyfyCommission}</td>
                              <td>{report?.commissionAmount}</td>
                              <td>
                                {Array.isArray(report?.vendorChargeArray) &&
                                  report.vendorChargeArray.map((vals, i) => (
                                    <span key={i}>
                                      <b>
                                        {`${vals?.title}: ${vals?.charge}`}
                                        {i < report.vendorChargeArray.length - 1
                                          ? ", "
                                          : ""}
                                      </b>
                                    </span>
                                  ))}
                              </td>
                              <td>{report?.totalExtraChargeVendor}</td>
                              <td>{report?.totalExtraTaxVendor}</td>
                              <td>
                                {Array.isArray(report?.guestChargeArray) &&
                                  report.guestChargeArray.map((vals, i) => (
                                    <span key={i}>
                                      <b>
                                        {`${vals?.title}: ${vals?.charge}`}
                                        {i < report.guestChargeArray.length - 1
                                          ? ", "
                                          : ""}
                                      </b>
                                    </span>
                                  ))}
                              </td>
                              <td>{report?.totalExtraChargeGuest}</td>
                              <td>{report?.totalExtraTaxGuest}</td>
                              {/* <td>{report?.platformcharge}</td>
                                    <td>{report?.gatewayCharge}</td>
                                    <td>{report?.techAssistance}</td> */}
                              <td>{report?.paymentMadeToOutletFromSortyfy}</td>
                              <td>{report?.noShowPercent}</td>
                              <td>{report?.noShowAmount}</td>
                              <td>{report?.fullFinalPaymentSettlement}</td>
                              <td>{report?.paymentStatus}</td>
                              <td>{report?.commissionPaymentDetails}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center" }} colSpan="7">
                            No Reports Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          {data.length > 0 && (
            <Pagination
              page={page}
              totalDocuments={totalDocuments}
              getNewData={fetchMoreData}
              perPage={perPage}
              currentDocLength={data.length}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAll;
